import request from '@/utils/request';


export default {
    // 获取评价期列表
    getAllDate: (param) => {
        return request({
            url: `/produceScore/getAppraisePeriodDictionList`,
            method: 'get',
            data:param
        });
    },
    // 获取等级
    getGradeDictionList: (param) => {
        return request({
            url: `/produceScore/getGradeDictionList`,
            method: 'get',
            data:param
        });
    },
    // 获取状态
    getStatusList: (param) => {
        return request({
            url: `/produceScore/getStatusDictionList`,
            method: 'get',
            data:param
        });
    },
    // 查询数据
    getdPageList: (param) => {
        return request({
            url: `/produceScore/pageList`,
            method: 'post',
            data:param
        });
    },
    // 查询详情
    getDetailInfo: (proteinScoreId) => {
        return request({
            url: `/produceScore/detail/${proteinScoreId}/allList`,
            method: 'get',
        });
    },
    // 评分任务保存
    saveScoreInfo: (param,proteinScoreId) => {
        return request({
            url: `produceScore/detail/${proteinScoreId}/saveScoreInfo`,
            method: 'post',
            data:param
        });
    },
    // 供应商评分提交
    appraise: (id) => {
        return request({
            url: `/produceScore/appraise/${id}`,
            method: 'get',
        });
    },
    // 批量批准
    approvalBatch: (param) => {
        return request({
            url: `/produceScore/approvalBatch`,
            method: 'post',
            data:param
        });
    },
    // 批量退回
    rejectBatch: (param) => {
        return request({
            url: `/produceScore/rejectBatch`,
            method: 'post',
            data:param
        });
    },
    // 导出
    exportProteinScore: (param) => {
        return request({
            url: `/produceScore/exportProteinScore`,
            method: 'post',
            data:param,
            responseType: "blob",
            fullResponse: true,
        });
    },
    // 导出（含Facts）
    exportProteinScoreHasFacts: (param) => {
        return request({
            url: `/produceScore/exportProteinScoreHasFacts`,
            method: 'post',
            data:param,
            responseType: "blob",
            fullResponse: true,
        });
    },
    
    
    
}



